import type { CSSProperties } from "react";
import { useMemo } from "react";

interface UseMsoStylesOptions {
  linkStyles: CSSProperties;
}

// normalize number|string to px string
const toPx = (v: unknown): string => {
  if (v == null) return "0";
  if (typeof v === "number") return `${v}px`;
  // eslint-disable-next-line @typescript-eslint/no-base-to-string -- Updating typescript-eslint, should be fixed when appropriate
  const s = String(v).trim();
  return s.endsWith("px") ? s : `${s}px`;
};

export const useMsoStyles = ({ linkStyles }: UseMsoStylesOptions) =>
  useMemo(() => {
    const any = linkStyles as Record<string, unknown>;

    // Extract padding values directly (we always have explicit values from defaultStyles)
    const msoPadding = `${toPx(any.paddingTop)} ${toPx(any.paddingRight)} ${toPx(any.paddingBottom)} ${toPx(any.paddingLeft)}`;

    // Extract background and border from computed styles
    const msoBg = String(linkStyles.backgroundColor ?? "");
    const msoBorderColor = String(linkStyles.borderColor ?? "transparent");
    const msoBorderWidth = toPx(linkStyles.borderWidth);

    return {
      msoPadding,
      msoBg,
      msoBorderColor,
      msoBorderWidth,
    };
  }, [linkStyles]);

// Tiny helper to inject MSO-only HTML without extra deps
export const Mso = ({ html }: { html: string }) => (
  <span
    style={{ fontSize: 0, lineHeight: 0 }}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);
